// src/auth/tokenService.ts
import { getAuth0Token } from './utils';


// Check if token exists
export const hasToken = (): boolean => {
  const token = getAuth0Token();
  return !!token;
};

// Check if token is valid (not expired)
export const isTokenValid = (): boolean => {
  try {
    const token = getAuth0Token();
    if (!token) return false;

    // Parse JWT payload
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const { exp } = JSON.parse(jsonPayload);
    const currentTime = Math.floor(Date.now() / 1000);
    
    // Token is valid if expiration time is in the future
    return exp > currentTime;
  } catch {
    return false;
  }
};

// Check if token will expire soon (within 5 minutes)
export const willTokenExpireSoon = (): boolean => {
  try {
    const token = getAuth0Token();
    if (!token) return true;

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const { exp } = JSON.parse(jsonPayload);
    const currentTime = Math.floor(Date.now() / 1000);
    const fiveMinutes = 5 * 60; // 5 minutes in seconds

    // Token will expire soon if it expires within 5 minutes
    return exp - currentTime < fiveMinutes;
  } catch {
    return true; // Assume it will expire soon if there's an error
  }
};

// Extract user info from token
export const getUserInfoFromToken = () => {
  try {
    const token = getAuth0Token();
    if (!token) return null;

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

export default {
  hasToken,
  isTokenValid,
  willTokenExpireSoon,
  getUserInfoFromToken
};